import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n      animation-name: ", ";\n      animation-iteration-count: 1;\n      animation-timing-function: linear;\n      animation-fill-mode: both;\n      animation-duration: ", "s;\n    "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  stroke-dashoffset: 0;\n  stroke-dasharray: ", "px;\n  stroke-miterlimit: 12px;\n  ", "\n\n  ", "\n\n  ", "\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n      animation: ", " 1.125s cubic-bezier(0.5, 0.1, 0.5, 0.9)\n        infinite;\n    "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  0% { transform: rotateZ(-45deg); }\n  100% { transform: rotateZ(1035deg); }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  0% { stroke-dashoffset: 0; }\n  100% { stroke-dashoffset: ", "px; }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  stroke-width: 1.5px;\n  stroke: ", ";\n  fill: none;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  fill: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", " ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled, { keyframes, css } from 'styled-components';
import { cobaltBlue, poppyRed, goldfish, mystic } from '../../styles/colors';
var circleRadius = '40';
var pi = 3.14159265359;
var circleCircumference = "".concat(2 * pi * circleRadius);
var stroke = "\n  stroke-width: 4px;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n  fill: none;\n";
var statusColors = {
  success: cobaltBlue,
  fail: poppyRed,
  warn: goldfish,
  pending: cobaltBlue
};
export var Icon = styled.path(_templateObject(), stroke, function (_ref) {
  var status = _ref.status;
  var statusColor = statusColors[status];

  if (statusColor) {
    return "\n        stroke: ".concat(statusColor, ";\n      ");
  }

  return '';
});
export var IconFill = styled.path(_templateObject2(), goldfish);
export var LightCircle = styled.circle(_templateObject3(), mystic);
var countdownAnimation = keyframes(_templateObject4(), circleCircumference * -1);
var loadingSpinner = keyframes(_templateObject5());
export var Svg = styled.svg(_templateObject6(), function (_ref2) {
  var status = _ref2.status;
  return status === 'pending' && css(_templateObject7(), loadingSpinner);
});
export var Circle = styled.path(_templateObject8(), stroke, circleCircumference, function (_ref3) {
  var countdown = _ref3.countdown;
  return countdown && css(_templateObject9(), countdownAnimation, countdown);
}, function (_ref4) {
  var status = _ref4.status;
  return status === 'pending' && "\n    stroke-dashoffset: ".concat(circleCircumference * 0.75, "px;\n  ");
}, function (_ref5) {
  var color = _ref5.color,
      status = _ref5.status;
  var statusColor = color || statusColors[status];

  if (statusColor) {
    return "\n        stroke: ".concat(statusColor, ";\n      ");
  }

  return '';
});